import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule} from '@angular/forms';
import { FormsModule } from "@angular/forms";
import {NgxWebstorageModule} from 'ngx-webstorage';

import { AuthRoutingModule } from './auth-routing.module';
import {LoginComponent, RegisterComponent, ForgetPasswordComponent
        , VendorRegisterProfileComponent, VendorRegisterProfile1Component,
        ResetPasswordComponent,RegistrationStatusComponent
        } from './components';
import { UserService } from './services';

//prime-ng
import {TableModule} from 'primeng/table';
import {ToastModule} from 'primeng/toast';
import {CalendarModule} from 'primeng/calendar';
import {SliderModule} from 'primeng/slider';
import {MultiSelectModule} from 'primeng/multiselect';
import {ContextMenuModule} from 'primeng/contextmenu';
import {DialogModule} from 'primeng/dialog';
import {ButtonModule} from 'primeng/button';
import {DropdownModule} from 'primeng/dropdown';
import {ProgressBarModule} from 'primeng/progressbar';
import {InputTextModule} from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import {MenubarModule} from 'primeng/menubar';
import {MessagesModule} from 'primeng/messages';
import { ConfirmPopupModule } from "primeng/confirmpopup";
import { CardModule } from 'primeng/card';
import { PanelModule } from "primeng/panel";
import {PasswordModule} from 'primeng/password';
import {InputNumberModule} from 'primeng/inputnumber';

import {InputSwitchModule} from 'primeng/inputswitch';
import {CheckboxModule} from 'primeng/checkbox';
import {TabViewModule} from 'primeng/tabview';
import {AccordionModule} from 'primeng/accordion';
import {FileUploadModule} from 'primeng/fileupload';
import { ChartsModule,ThemeService } from 'ng2-charts';
import {EditorModule} from 'primeng/editor';
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { BlockPasteDirective } from '../shared/directives/blockpaste';
import { EmailUnsubscribeComponent } from './components/email-unsubscribe/email-unsubscribe.component';
import { TimelineModule } from 'primeng/timeline';
import { TooltipModule } from 'primeng/tooltip';

import { NgxDocViewerModule } from 'ngx-doc-viewer';  
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { QuillModule } from 'ngx-quill'
import { CaptchaModule } from '../captcha/captcha.module';
@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ForgetPasswordComponent,
    VendorRegisterProfileComponent,
    VendorRegisterProfile1Component,
    ResetPasswordComponent,
    BlockPasteDirective,
    EmailUnsubscribeComponent,
    RegistrationStatusComponent
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    InputNumberModule,
    TimelineModule,
    TooltipModule,
    ChartsModule,
    TableModule,
    CalendarModule,
		SliderModule,
		DialogModule,
		MultiSelectModule,
		ContextMenuModule,
		DropdownModule,
		ButtonModule,
		ToastModule,
    InputTextModule,
    ProgressBarModule,
    MenuModule,
    MenubarModule,
    CardModule,
    PanelModule,
    TabViewModule,
    InputSwitchModule,
    CheckboxModule,
    MessagesModule,
    FileUploadModule,
    AccordionModule,
    ConfirmPopupModule,
    PasswordModule,
    NgxMaskModule.forRoot(),
    NgxWebstorageModule.forRoot(),
    EditorModule,
    PdfViewerModule,
    NgxDocViewerModule,
    ProgressSpinnerModule,
    ConfirmDialogModule,
    TooltipModule,
    QuillModule.forRoot(),
    CaptchaModule
  ],
  providers: [
    UserService,
  ],
})
export class AuthModule { }
